import { isUrsa } from "../../../util/themeHelper";
import { BaseButtonStyledProps } from "../types";

export const getTextDecoration = ({ appearance, renderAs, state, themeMode }: BaseButtonStyledProps): string => {
    // necessary for links that render to look like buttons
    if (appearance !== "link" && !state.isFocus) return "none";

    // handles links that render as links
    return renderAs === "a" &&
        !state.isDisabled &&
        (isUrsa(themeMode) || state.isActive || state.isHover || state.isFocus)
        ? "underline"
        : "none";
};
